import {getEnumKeys} from '../../../types/types';
import {ICONS} from '../../images/images';
import {Feed} from './Feed';

export const FEED_ICONS_MAP: Record<Feed, string> = getEnumKeys(Feed).reduce((acc, feed) => {
  // @ts-ignore
  return {...acc, [feed as Feed]: ICONS['FEED_' + feed]};
}, {} as Record<Feed, string>);
